import { Goerli } from "@usedapp/core";

export const ROUTER_ADDRESS = "0x73170963149a02711692bb88B0f8552E424e870F"; 

export const DAPP_CONFIG = {
  readOnlyChainId: Goerli.chainId,
  readOnlyUrls: {
    [Goerli.chainId]: "https://eth-goerli.g.alchemy.com/v2/kdHtVv-Y2Tl1fb9oU_Pc_XKwEfLNXV7x",
  },
};